export const SESSION_FIELDS = {
  AREA_OF_DEVELOPMENT: "areaOfDevelopment",
  LONG_TERM_GOAL: "longTermGoal",
  MOTIVATION: "motivation",
  REFLECTION: "reflection",
  ACTION_STEPS: "actionSteps", // new items can be added in UI
  PREV_ACTION_STEPS: "previousActionSteps", // items can be checked as completed in UI
};
